import React, { useState } from "react";
import { Link, Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { logoutUser } from "../../api/api";
import { restoreActiveSessionToken, setSessionToken } from "../../lib/sessionToken";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";
import { Button } from "../ui/button";

/**
 * Isolated admin application mounted only under /platform-admin/*.
 * @returns {JSX.Element}
 */
function AdminApp() {
  const navigate = useNavigate();
  const [admin, setAdmin] = useState(null);

  /**
   * Clear admin session state and redirect to admin login.
   * @returns {void}
   */
  async function onLogout() {
    await logoutUser();
    if (!restoreActiveSessionToken()) {
      setSessionToken("");
    }
    setAdmin(null);
    navigate("/platform-admin/login");
  }

  return (
    <div className="bg-ui-background min-h-screen">
      <header className="border-b border-ui-border bg-ui-card">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3">
          <Link to="/platform-admin/pending" className="text-lg font-bold text-accent">
            Assembly admin
          </Link>
          {admin ? (
            <Button variant="outline" onClick={onLogout}>
              Logout
            </Button>
          ) : null}
        </div>
      </header>

      <Routes>
        <Route path="/login" element={<AdminLogin onSetAdmin={setAdmin} />} />
        <Route
          path="/*"
          element={admin ? <AdminDashboard admin={admin} /> : <Navigate to="/platform-admin/login" replace />}
        />
      </Routes>
    </div>
  );
}

export default AdminApp;
